<template>
  <div class="domain-container">
    <div class="page-header">
      <h2>{{ $t('domainList.title') }}</h2>
      <div class="header-actions">
        <!-- <el-button size="medium" @click = "$router.push('/domain/group')">{{ $t('domainGroupList.groupManage') }}</el-button>
        <el-button type="primary" size="medium" @click="$router.push('/domain/register')">{{ $t('domainList.registerNew') }}</el-button> -->
      </div>
    </div>

    <div class="filter-container">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item :label="$t('domainList.domain')">
          <el-input v-model="filterForm.keyword" :placeholder="$t('domainList.keywordPlaceholder')" @keyup.enter.native="handleSearch" clearable></el-input>
        </el-form-item>
       <!-- <el-form-item :label="$t('domainList.status')">
          <el-select v-model="filterForm.status" :placeholder="$t('domainList.allStatus')" clearable>
            <el-option :label="$t('domainList.allStatus')" value=""></el-option>
            <el-option :label="$t('domainList.normal')" value="normal"></el-option>
            <el-option :label="$t('domainList.expiring')" value="expiring"></el-option>
            <el-option :label="$t('domainList.expired')" value="expired"></el-option>
            <el-option :label="$t('domainList.disabled')" value="disabled"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('domainList.group')">
          <el-select v-model="filterForm.group_id" :placeholder="$t('domainList.selectGroup')" clearable>
            <el-option
                v-for="item in groupOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('domainList.search') }}</el-button>
          <el-button @click="resetFilter">{{ $t('domainList.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="domainList"
      border
      v-loading="loading"
      style="width: 100%">
      <el-table-column prop="domain" :label="$t('domainList.domain')" min-width="180">
        <template slot-scope="scope">
          <div class="domain-name">
            <span>{{ scope.row.domain }}</span>
            <el-tag v-if="isExpiring(scope.row)" size="mini" type="warning">{{ $t('domainList.expiring') }}</el-tag>
            <el-tag v-if="isExpired(scope.row)" size="mini" type="danger">{{ $t('domainList.expired') }}</el-tag>
          </div>
        </template>
      </el-table-column>
	  
	  
	  
	  <el-table-column align="center" width="140" prop="user_name" :label="$t('cdn.user')">
	  	<template slot-scope="scope">
	  		{{scope.row.user_name}}
	  		
	  	</template>
	  </el-table-column>
	  
	  
	  
	  
      <el-table-column prop="registrationDate" :label="$t('domainList.registrationDate')" width="120" :formatter="formatDate"></el-table-column>
      <el-table-column prop="expiryDate" :label="$t('domainList.expiryDate')" width="120" :formatter="formatDate"></el-table-column>
      <el-table-column prop="status" :label="$t('domainList.status')" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('组名称')" width="160">
        <template v-slot="scope">
          <el-select v-model="scope.row.group_id" clearable placeholder="请选择组名" @change="handleGroupChange(scope.row, $event)">
            <el-option
                v-for="item in groupOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"

            >
            </el-option>
          </el-select>
        </template>
      </el-table-column> -->
<!--      <el-table-column prop="dnsProvider" :label="$t('domainList.dnsProvider')" width="120"></el-table-column>-->
      <!-- <el-table-column prop="autoRenew" :label="$t('domainList.autoRenew')" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.autoRenew"
            @change="handleAutoRenewChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :label="$t('domainList.operation')" width="280" align="center" fixed="right">
        <template slot-scope="scope">
         
          <el-button type="text" size="small" @click="handleDnsManage(scope.row)">{{ $t('domainList.dnsManage') }}</el-button>
        
          <el-button type="text" size="small" @click="handleWhois(scope.row)">{{ $t('domainList.whois') }}</el-button>
         
        </template>
      </el-table-column> -->
    </el-table>
    
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 续费对话框 -->
    <el-dialog
      :title="$t('domainList.renewTitle')"
      :visible.sync="renewDialog.visible"
      append-to-body
      :modal-append-to-body="false"
      width="500px">
      <div class="renew-dialog">
        <p>{{ $t('domainList.domain') }}: <strong>{{ renewDialog.domain && renewDialog.domain.domain }}</strong></p>
        <p>{{ $t('domainList.currentExpiry') }}: {{ formatDate(null, renewDialog.domain) }}</p>
        
        <el-form :model="renewDialog.form" label-width="100px" class="renew-form">
          <el-form-item :label="$t('domainList.renewYears')">
            <el-select v-model="renewDialog.form.years" placeholder="请选择续费年限">
              <el-option
                v-for="year in getAvailableRenewYears()"
                :key="year"
                :label="year + ' ' + $t('domain.year')"
                :value="year">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="price-calculation">
              <span>{{ $t('domainList.renewPrice') }}: </span>
              <span class="price">{{ calculateRenewPrice() }}元</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="renewDialog.visible = false">{{ $t('system.cancel') }}</el-button>
        <el-button type="primary" @click="confirmRenew" :loading="renewDialog.loading">{{ $t('domainList.confirmRenew') }}</el-button>
      </div>
    </el-dialog>

    <!-- DNS管理对话框 -->
    <el-dialog
      :title="$t('domainList.dnsTitle')"
      :visible.sync="dnsDialog.visible"
      append-to-body
      :modal-append-to-body="false"
      width="800px">
      <div class="dns-dialog" v-loading="dnsDialog.loading">
        <p>{{ $t('domainList.domain') }}: <strong>{{ dnsDialog.domain && dnsDialog.domain.domain }}</strong></p>
        
        <div class="dns-actions">
          <el-button type="primary" size="small" @click="handleAddDnsRecord">{{ $t('domainList.addRecord') }}</el-button>
        </div>
        
        <el-table :data="dnsDialog.records" border style="width: 100%; margin-top: 15px;">
          <el-table-column prop="type" :label="$t('domainList.recordType')" width="100">
            <template slot-scope="scope">
              <el-select v-model="scope.row.type" size="mini" :disabled="!scope.row.isEditing">
                <el-option label="A" value="A"></el-option>
                <el-option label="AAAA" value="AAAA"></el-option>
                <el-option label="CNAME" value="CNAME"></el-option>
                <el-option label="MX" value="MX"></el-option>
                <el-option label="TXT" value="TXT"></el-option>
                <el-option label="NS" value="NS"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('domainList.recordHost')" width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name" size="mini" :disabled="!scope.row.isEditing"></el-input>
            </template>
          </el-table-column>
		  
		  
          <el-table-column prop="value" :label="$t('domainList.recordValue')" min-width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.value" size="mini" :disabled="!scope.row.isEditing"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priority" :label="$t('domainList.recordPriority')" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.priority" size="mini" :disabled="!scope.row.isEditing || scope.row.type !== 'MX'"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ttl" :label="$t('domainList.recordTTL')" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ttl" size="mini" :disabled="!scope.row.isEditing"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('domainList.operation')" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.isEditing">
                <el-button type="text" size="mini" @click="saveDnsRecord(scope.row)">{{ $t('domainList.save') }}</el-button>
                <el-button type="text" size="mini" @click="cancelEditDnsRecord(scope.row)">{{ $t('domainList.cancel') }}</el-button>
              </div>
              <div v-else>
                <el-button type="text" size="mini" @click="editDnsRecord(scope.row)">{{ $t('domainList.edit') }}</el-button>
                <el-button type="text" size="mini" class="delete-btn" @click="deleteDnsRecord(scope.row)">{{ $t('domainList.delete') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    
    <!-- Whois信息对话框 -->
<!--    <el-dialog-->
<!--      :title="$t('domainList.whoisTitle') + (whoisDialog.domain ? ' - ' + whoisDialog.domain.domain : '')"-->
<!--      :visible.sync="whoisDialog.visible"-->
<!--      append-to-body-->
<!--      :modal-append-to-body="false"-->
<!--      width="800px">-->
    <el-dialog
        :title="$t('domainList.whoisTitle') + (whoisDialog.domain ? ' - ' + whoisDialog.domain.domain : '')"
        :visible.sync="whoisDialog.visible"
        width="800px"
        append-to-body>
      <div class="whois-dialog" v-loading="whoisDialog.loading">
        <div v-if="whoisDialog.info && typeof whoisDialog.info === 'object'">
          <el-tabs v-model="whoisDialog.activeTab" type="border-card">
            <!-- 基本信息标签页 -->
            <el-tab-pane label="基本信息" name="basic">
              <div class="tab-header">
                <i class="el-icon-document"></i>
                <span>域名基本信息</span>
              </div>
              <el-descriptions :column="2" border size="medium">
                <el-descriptions-item label="域名">{{ whoisDialog.info.domain }}</el-descriptions-item>
				
				
                <el-descriptions-item label="注册时间">{{ whoisDialog.info.register_time }}</el-descriptions-item>
                <el-descriptions-item label="到期时间">{{ whoisDialog.info.expiration_time }}</el-descriptions-item>
                <el-descriptions-item label="注册状态">{{ whoisDialog.info.register_status === 2 ? '已注册' : '未注册' }}</el-descriptions-item>
                <el-descriptions-item label="服务商">{{ whoisDialog.info.service }}</el-descriptions-item>
                <el-descriptions-item label="添加时间">{{ whoisDialog.info.add_time }}</el-descriptions-item>
              </el-descriptions>
            </el-tab-pane>
            
            <!-- 注册人信息标签页 -->
            <el-tab-pane label="注册人信息" name="registrant">
              <div class="tab-header">
                <i class="el-icon-user"></i>
                <span>注册人详细信息</span>
              </div>
              <el-descriptions :column="2" border size="medium">
                <el-descriptions-item label="注册人">{{ whoisDialog.info.name }}</el-descriptions-item>
                <el-descriptions-item label="注册人(英文)">{{ whoisDialog.info.name_en }}</el-descriptions-item>
                <el-descriptions-item label="联系人">{{ whoisDialog.info.contact }}</el-descriptions-item>
                <el-descriptions-item label="联系人(英文)">{{ whoisDialog.info.contact_en }}</el-descriptions-item>
                <el-descriptions-item label="电子邮箱">{{ whoisDialog.info.email }}</el-descriptions-item>
                <el-descriptions-item label="手机号码">{{ whoisDialog.info.mobile }}</el-descriptions-item>
                <el-descriptions-item label="联系地址">{{ whoisDialog.info.address }}</el-descriptions-item>
                <el-descriptions-item label="联系地址(英文)">{{ whoisDialog.info.address_en }}</el-descriptions-item>
                <el-descriptions-item label="所在地区">{{ whoisDialog.info.city }}</el-descriptions-item>
                <el-descriptions-item label="邮政编码">{{ whoisDialog.info.pc }}</el-descriptions-item>
                <el-descriptions-item label="注册人ID">{{ whoisDialog.info.registrant_id }}</el-descriptions-item>
                <el-descriptions-item label="证件号码">
                  <span class="sensitive-info">{{ maskIdCard(whoisDialog.info.id_code) }}</span>
                </el-descriptions-item>
              </el-descriptions>
            </el-tab-pane>
            
            <!-- DNS服务器标签页 -->
            <el-tab-pane label="DNS服务器" name="dns">
              <div class="tab-header">
                <i class="el-icon-connection"></i>
                <span>DNS服务器配置</span>
              </div>
              <div class="dns-server">
                <el-tag v-for="(item, index) in whoisDialog.info.dns" :key="index">{{ item }}</el-tag>
              </div>

              <el-descriptions :column="2" border size="medium">
                <el-descriptions-item label="DNS服务器1">{{ whoisDialog.info.dns1 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="DNS服务器2">{{ whoisDialog.info.dns2 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="DNS服务器3">{{ whoisDialog.info.dns3 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="DNS服务器4">{{ whoisDialog.info.dns4 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="DNS服务器5">{{ whoisDialog.info.dns5 || '-' }}</el-descriptions-item>
                <el-descriptions-item label="DNS服务器6">{{ whoisDialog.info.dns6 || '-' }}</el-descriptions-item>
              </el-descriptions>
              <el-button type="primary" @click="editDns">{{ $t('修改DNS服务器') }}</el-button>
            </el-tab-pane>
            <el-dialog
                width="500px"
                title="修改DNS服务器"
                :visible.sync="whoisDialog.innerVisible"
                append-to-body>
              <el-form :model="domainDnsForm" status-icon :rules="rules" ref="domainDnsForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="DNS服务器">
                  <el-radio-group v-model="domainDnsForm.radio">
                    <el-radio :label="0">默认DNS</el-radio>
                    <el-radio :label="1">自定义DNS</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div v-if="domainDnsForm.radio === 1">
                  <el-form-item
                      v-for="i in totalDns"
                      :key="i"
                      :label="'DNS' + i"
                      :prop="'DNS' + i"
                  >
                    <el-input v-model="domainDnsForm['DNS' + i]"></el-input>
                  </el-form-item>
                  <!-- 添加按钮（当未达到最大数量时显示） -->
                  <el-form-item v-if="totalDns < 6">
                    <el-button
                        type="text"
                        @click="totalDns += 1"
                        icon="el-icon-plus"
                    >
                      添加DNS服务器
                    </el-button>
                  </el-form-item>
                </div>
                <div v-else>
                  <el-form-item label="DNS1">
                    <el-input v-model="domainDnsDefForm.DNS1" :disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item label="DNS2">
                    <el-input v-model="domainDnsDefForm.DNS2" :disabled="true"></el-input>
                  </el-form-item>
                </div>

              </el-form>
              <div style="text-align: right">
                <el-button @click="whoisDialog.innerVisible = false" >取消</el-button>
                <el-button type="primary" @click="submitDnsForm()" >确认</el-button>
              </div>
            </el-dialog>
            <!-- 状态信息标签页 -->
            <el-tab-pane label="状态信息" name="status">
              <div class="tab-header">
                <i class="el-icon-s-flag"></i>
                <span>域名状态信息</span>
              </div>
              <el-descriptions :column="3" border size="medium">
                <el-descriptions-item label="禁止转移">
                  <el-tag :type="whoisDialog.info.forbidden_transfer ? 'danger' : 'success'">
                    {{ whoisDialog.info.forbidden_transfer ? '是' : '否' }}
                  </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="禁止更新">
                  <el-tag :type="whoisDialog.info.forbidden_update ? 'danger' : 'success'">
                    {{ whoisDialog.info.forbidden_update ? '是' : '否' }}
                  </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="冻结状态">
                  <el-tag :type="whoisDialog.info.freeze ? 'danger' : 'success'">
                    {{ whoisDialog.info.freeze ? '是' : '否' }}
                  </el-tag>
                </el-descriptions-item>
              </el-descriptions>
            </el-tab-pane>
          </el-tabs>
        </div>
        
        <!-- 处理非对象情况 -->
        <div class="whois-info" v-else-if="whoisDialog.info">
          <pre>{{ whoisDialog.info }}</pre>
        </div>
        
        <!-- 无数据情况 -->
        <el-empty v-else description="暂无数据"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DomainManagement',
  data() {
    return {
      // 域名列表
      domainList: [],
      // 加载状态
      loading: false,
      // 过滤表单
      filterForm: {
        keyword: '',
        status: '',
        group_id: ''
      },
      domainDnsDefForm:{
        DNS1: 'ns1.kenpains.com',
        DNS2: 'ns2.kenpains.com'
      },
      domainDnsForm:{
        radio: 1,
        DNS1: '',
        DNS2: '',
        DNS3: '',
        DNS4: '',
        DNS5: '',
        DNS6: ''
      },
      totalDns : 0,
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 续费对话框
      renewDialog: {
        visible: false,
        domain: null,
        loading: false,
        pricePerYear: 0, // 每年续费价格
        form: {
          years: 1
        }
      },
      // DNS管理对话框
      dnsDialog: {
        visible: false,
        domain: null,
        loading: false,
        records: []
      },
      // Whois对话框
      whoisDialog: {
        visible: false,
        domain: null,
        loading: false,
        info: '',
        activeTab: 'basic',
        innerVisible: false
      },
      // 域名价格数据
      domainPriceData: {},
      groupOptions : [],
      rules: {
        DNS1: [
          { required: true, message: '请输入DNS服务器1', trigger: 'blur' }
        ],
        DNS2: [
          { required: true, message: '请输入DNS服务器2', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    this.fetchDomainList()
    //this.loadDomainPrices()
    //this.getDomainGroup()
  },
  methods: {
    // 获取域名价格表
    loadDomainPrices() {
      this.axios.post('/admin/domain/getDomainAllPrice', {}, {
        token: true
      }).then(res => {
        const { status, data } = res;
        if (status === 200 && data && data.code === 1) {
          const list = data.data.list;
          
          // 处理域名价格数据
          if (list && list.length > 0) {
            // 保存完整价格数据
            this.domainPriceData = {};
            list.forEach(item => {
              this.domainPriceData[item.suffix] = item.price;
            });
          }
        }
      }).catch(err => {
        console.error('获取域名价格数据失败', err);
      })
    },
    // 获取域名列表
    fetchDomainList() {
      this.loading = true
      
      // 构建API请求参数
      const params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        keyword: this.filterForm.keyword,
        status: this.filterForm.status,
        group_id: this.filterForm.group_id
      }
      
      console.log('params: ', params);
      
      // 发起API请求获取域名列表
      this.axios.post('/admin/domain/domainList', params, {
        token: true
      }).then(res => {
        const { status, msg, data } = res
        console.log(res);
        
        if (status === 200 && data && data.data && data.code == 1) {
          const { list, total } = data.data.list;
          // 转换API返回的数据格式为组件需要的格式
          this.domainList = list.map(item => ({
            id: item.id,
            domain: item.domain,
            suffix: item.suffix,
            registrationDate: new Date(item.register_time * 1000),
            expiryDate: new Date(item.expire_time * 1000),
            status: item.status,
            autoRenew: item.auto_renew === 1,
            dnsStatus: item.dns_status === 1,
            locked: item.status === 'locked',
            create_time: item.create_time,
            template_id: item.template_id,
            user_name: item.user_name,
            dnsProvider: '默认DNS', // 默认值，如果API返回了DNS提供商信息，可以替换
            group_id: item.group_id || null
          }))
          
          // 更新分页信息
          this.pagination.total = total || this.domainList.length
        } else {
          this.$message.error(msg || '获取域名列表失败')
          this.domainList = []
        }
        
        this.loading = false
      }).catch(error => {
        console.error('获取域名列表失败:', error)
        this.$message.error('获取域名列表失败，请稍后重试')
        this.loading = false
        this.domainList = []
      })
    },
    
    // 应用过滤条件 - 现在由服务端API处理
    applyFilters(data) {
      // 保留此方法以便将来可能的本地过滤需求
      return data
    },
    
    // 重置过滤条件
    resetFilter() {
      this.filterForm = {
        keyword: '',
        status: '',
        group_id: ''
      }
      this.handleSearch()
    },
    
    // 处理搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchDomainList()
    },
    
    // 判断域名是否即将到期 (30天内)
    isExpiring(domain) {
      // 如果状态字段已经是expiring，直接返回true
      if (domain.status === 'expiring') return true
      
      // 否则根据到期时间计算
      const now = new Date()
      return !this.isExpired(domain) && this.getDaysDiff(now, domain.expiryDate) <= 30
    },
    
    // 判断域名是否已过期
    isExpired(domain) {
      // 如果状态字段已经是expired，直接返回true
      if (domain.status === 'expired') return true
      
      // 否则根据到期时间计算
      const now = new Date()
      return domain.expiryDate < now
    },
    
    // 计算两个日期之间的天数差
    getDaysDiff(date1, date2) {
      const diffTime = Math.abs(date2 - date1)
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    },
    
    // 获取状态类型
    getStatusType(status) {
      const map = {
        'normal': 'success',
        'expiring': 'warning',
        'expired': 'danger',
        'disabled': 'info'
      }
      return map[status] || 'info'
    },
    
    // 获取状态文本
    getStatusText(status) {
      return this.$t(`domainList.${status}`) || status
    },
    
    // 格式化日期
    formatDate(row, column) {
      let date
      if (column) {
        if (typeof column === 'object' && column.expiryDate) {
          date = column.expiryDate
        } else if (typeof column === 'object' && column.registrationDate) {
          date = column.registrationDate
        } else {
          date = row[column.property]
        }
      } else if (row && row.expiryDate) {
        date = row.expiryDate
      }
      
      if (!date) return '--'
      
      // 处理时间戳格式
      const timestamp = typeof date === 'number' ? date * 1000 : date
      const d = new Date(timestamp)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      
      return `${year}-${month}-${day}`
    },
    
    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchDomainList()
    },
    
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.fetchDomainList()
    },
    
    // 处理自动续费变更
    handleAutoRenewChange(domain) {
      const params = {
        domain_id: domain.id,
        auto_renew: domain.autoRenew ? 1 : 0
      }
      
      this.axios.post('/admin/domain/updateAutoRenew', params, {
        token: true
      }).then(res => {
        const { status, msg } = res
        
        if (status === 200) {
          this.$message.success(domain.autoRenew 
            ? this.$t('domainList.autoRenewOn') 
            : this.$t('domainList.autoRenewOff'))
        } else {
          // 恢复原状态
          domain.autoRenew = !domain.autoRenew
          this.$message.error(msg || '更新自动续费状态失败')
        }
      }).catch(error => {
        console.error('更新自动续费状态失败:', error)
        // 恢复原状态
        domain.autoRenew = !domain.autoRenew
        this.$message.error('更新自动续费状态失败，请稍后重试')
      })
    },
    
    // 处理域名锁定/解锁
    handleDomainLock(domain) {
      const newStatus = domain.locked ? 'normal' : 'locked'
      const params = {
        domain_id: domain.id,
        status: newStatus
      }
      
      this.axios.post('/admin/domain/updateDomainStatus', params, {
        token: true
      }).then(res => {
        const { status, msg } = res
        
        if (status === 200) {
          domain.locked = !domain.locked
          domain.status = newStatus
          this.$message.success(domain.locked 
            ? this.$t('domainList.lockSuccess') 
            : this.$t('domainList.unlockSuccess'))
        } else {
          this.$message.error(msg || '更新域名状态失败')
        }
      }).catch(error => {
        console.error('更新域名状态失败:', error)
        this.$message.error('更新域名状态失败，请稍后重试')
      })
    },
    
    // 处理续费操作
    handleRenew(domain) {
      this.renewDialog.domain = domain
      this.renewDialog.form.years = 1
      this.renewDialog.visible = true
      
      // 从价格表中获取续费价格
      const suffix = '.' + domain.domain.split('.').slice(1).join('.');
      if (this.domainPriceData[suffix] && this.domainPriceData[suffix].renew && this.domainPriceData[suffix].renew['1']) {
        this.renewDialog.pricePerYear = this.domainPriceData[suffix].renew['1'];
      } else {
        // 如果没有找到对应的价格数据，从API获取
        this.axios.post('/admin/domain/getDomainPrice', {
          domain_id: domain.id,
          type: 'renew'
        }, {
          token: true
        }).then(res => {
          if (res.status === 200 && res.data && res.data.code == 1) {
            this.renewDialog.pricePerYear = res.data.data.price || 0
          } else {
            this.renewDialog.pricePerYear = 0
            this.$message.warning('获取域名续费价格失败')
          }
        }).catch(error => {
          console.error('获取域名续费价格失败:', error)
          this.renewDialog.pricePerYear = 0
        })
      }
    },
    
    // 计算续费价格
    calculateRenewPrice() {
      if (!this.renewDialog.domain) return 0
      
      // 获取域名后缀
      const suffix = '.' + this.renewDialog.domain.domain.split('.').slice(1).join('.');
      
      // 优先使用价格表中的数据
      if (this.domainPriceData[suffix] && 
          this.domainPriceData[suffix].renew && 
          this.domainPriceData[suffix].renew[this.renewDialog.form.years]) {
        return (this.domainPriceData[suffix].renew[this.renewDialog.form.years]).toFixed(2);
      }
      
      // 如果价格表中没有对应数据，使用从API获取的价格
      const price = this.renewDialog.pricePerYear || 0
      return (price * this.renewDialog.form.years).toFixed(2)
    },
    
    // 确认续费
    confirmRenew() {
      this.renewDialog.loading = true
      
      const params = {
        domain: this.renewDialog.domain.domain,
        years: this.renewDialog.form.years
      }
      
      this.axios.post('/admin/domain/renewDomain', params, {
        token: true
      }).then(res => {
        const { status, msg, data } = res
        console.log(res);
        
        if (status === 200) {
          // 更新到期时间
          const index = this.domainList.findIndex(item => item.id === this.renewDialog.domain.id)
          if (index !== -1 && data && data.data) {
            // 如果API返回了新的到期时间，使用API返回的值
            if (data.data.expire_time) {
              this.domainList[index].expiryDate = new Date(data.data.expire_time * 1000)
            } else {
              // 否则本地计算
              const newExpiryDate = new Date(this.domainList[index].expiryDate)
              newExpiryDate.setFullYear(newExpiryDate.getFullYear() + this.renewDialog.form.years)
              this.domainList[index].expiryDate = newExpiryDate
            }
            // 更新状态为正常
            this.domainList[index].status = 'normal'
          }
          
          this.$message.success(msg || this.$t('domainList.renewSuccess'))
          this.renewDialog.visible = false
        } else {
          this.$message.error(msg || '域名续费失败')
        }
        
        this.renewDialog.loading = false
      }).catch(error => {
        console.error('域名续费失败:', error)
        this.$message.error('域名续费失败，请稍后重试')
        this.renewDialog.loading = false
      })
    },
    
    // 处理DNS管理 - 跳转到DNS管理页面
    handleDnsManage(domain) {
      this.$router.push({
        path: `/domain/dns/${domain.id}`,
        query: {
          domain: domain.domain
        }
      });
    },
    
    // 添加DNS记录
    handleAddDnsRecord() {
      const newRecord = {
        id: Date.now(), // 临时ID
        type: 'A',
        name: '',
        value: '',
        ttl: 600,
        isEditing: true,
        originalData: null,
        isNew: true
      }
      this.dnsDialog.records.unshift(newRecord)
    },
    
    // 编辑DNS记录
    editDnsRecord(record) {
      record.originalData = JSON.parse(JSON.stringify(record))
      record.isEditing = true
    },
    
    // 取消编辑DNS记录
    cancelEditDnsRecord(record) {
      if (record.isNew) {
        // 如果是新添加的记录，直接从列表中移除
        const index = this.dnsDialog.records.findIndex(item => item.id === record.id)
        if (index !== -1) {
          this.dnsDialog.records.splice(index, 1)
        }
      } else {
        // 恢复原始数据
        Object.assign(record, record.originalData)
        record.isEditing = false
        record.originalData = null
      }
    },
    
    // 保存DNS记录
    saveDnsRecord(record) {
      // 简单验证
      if (!record.name || !record.value) {
        this.$message.error('主机记录和记录值不能为空')
        return
      }
      
      this.dnsDialog.loading = true
      
      // 构建请求参数
      const params = {
        domain_id: this.dnsDialog.domain.id,
        record: {
          type: record.type,
          name: record.name,
          value: record.value,
          ttl: record.ttl || 600
        }
      }
      
      // 如果是MX记录，添加优先级
      if (record.type === 'MX') {
        params.record.priority = record.priority || 10
      }
      
      // 如果是编辑现有记录，添加记录ID
      if (!record.isNew) {
        params.record.id = record.id
      }
      
      // 调用API保存记录
      const apiUrl = record.isNew ? '/admin/domain/addDnsRecord' : '/admin/domain/updateDnsRecord'
      
      this.axios.post(apiUrl, params, {
        token: true
      }).then(res => {
        const { status, msg, data } = res
        
        if (status === 200) {
          // 如果是新记录，更新ID为服务器返回的ID
          if (record.isNew && data && data.data && data.data.record_id) {
            record.id = data.data.record_id
            record.isNew = false
          }
          
          record.isEditing = false
          record.originalData = null
          this.$message.success(msg || this.$t('domainList.saveSuccess'))
        } else {
          this.$message.error(msg || '保存DNS记录失败')
        }
        
        this.dnsDialog.loading = false
      }).catch(error => {
        console.error('保存DNS记录失败:', error)
        this.$message.error('保存DNS记录失败，请稍后重试')
        this.dnsDialog.loading = false
      })
    },
    
    // 删除DNS记录
    deleteDnsRecord(record) {
      this.$confirm(this.$t('domainList.deleteRecordConfirm'), this.$t('system.prompt'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      }).then(() => {
        this.dnsDialog.loading = true
        
        this.axios.post('/admin/domain/deleteDnsRecord', {
          domain_id: this.dnsDialog.domain.id,
          record_id: record.id
        }, {
          token: true
        }).then(res => {
          const { status, msg } = res
          
          if (status === 200) {
            const index = this.dnsDialog.records.findIndex(item => item.id === record.id)
            if (index !== -1) {
              this.dnsDialog.records.splice(index, 1)
            }
            this.$message.success(msg || this.$t('domainList.deleteRecordSuccess'))
          } else {
            this.$message.error(msg || '删除DNS记录失败')
          }
          
          this.dnsDialog.loading = false
        }).catch(error => {
          console.error('删除DNS记录失败:', error)
          this.$message.error('删除DNS记录失败，请稍后重试')
          this.dnsDialog.loading = false
        })
      }).catch(() => {})
    },
    
    // 处理域名转出
    handleTransfer(domain) {
      this.$confirm(this.$t('domainList.transferConfirm'), this.$t('system.prompt'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      }).then(() => {
        this.$prompt(this.$t('domainList.transferPasswordPlaceholder'), this.$t('domainList.transferPasswordTitle'), {
          confirmButtonText: this.$t('system.confirm'),
          cancelButtonText: this.$t('system.cancel'),
          inputPattern: /^.{6,20}$/,
          inputErrorMessage: this.$t('domainList.transferPasswordError')
        }).then(({ value }) => {
          // 调用API进行域名转出
          this.axios.post('/admin/domain/transferDomain', {
            domain_id: domain.id,
            transfer_password: value
          }, {
            token: true
          }).then(res => {
            const { status, msg } = res
            
            if (status === 200) {
              this.$message.success(msg || this.$t('domainList.transferSuccess'))
              // 转出成功后刷新列表
              this.fetchDomainList()
            } else {
              this.$message.error(msg || '域名转出失败')
            }
          }).catch(error => {
            console.error('域名转出失败:', error)
            this.$message.error('域名转出失败，请稍后重试')
          })
        }).catch(() => {})
      }).catch(() => {})
    },
    
    // 处理Whois查询
    handleWhois(domain) {
      this.whoisDialog.domain = domain
      this.whoisDialog.loading = true
      this.whoisDialog.visible = true
      this.whoisDialog.info = ''
      this.whoisDialog.innerVisible =  false
      // 从API获取Whois信息
      this.axios.post('/admin/domain/detail', {
        domain: domain.domain
      }, {
        token: true
      }).then(res => {
        const { status, msg, data } = res
        console.log('whois info res', res);
        
        if (status === 200 && data && data.data) {
          // 处理API返回的数据
          this.whoisDialog.info = data.data.list || null;
          
          // 如果返回的不是对象，转为字符串显示
          if (this.whoisDialog.info && typeof this.whoisDialog.info !== 'object') {
            this.whoisDialog.info = String(this.whoisDialog.info);
          }
        } else {
          this.whoisDialog.info = '获取Whois信息失败: ' + (msg || '未知错误')
        }
        
        this.whoisDialog.loading = false
      }).catch(error => {
        console.error('获取Whois信息失败:', error)
        this.whoisDialog.info = '获取Whois信息失败，请稍后重试'
        this.whoisDialog.loading = false
      })
    },
    
    // 敏感信息处理
    maskIdCard(idCard) {
      if (!idCard) return '';
      const masked = idCard.slice(0, 4) + '**********' + idCard.slice(-4);
      return masked;
    },
    
    // 获取可用续费年限
    getAvailableRenewYears() {
      if (!this.renewDialog.domain) return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      
      // 获取域名后缀
      const suffix = '.' + this.renewDialog.domain.domain.split('.').slice(1).join('.');
      
      // 如果价格表中有对应的续费价格数据，使用价格表中的年限
      if (this.domainPriceData[suffix] && this.domainPriceData[suffix].renew) {
        const availableYears = Object.keys(this.domainPriceData[suffix].renew)
          .map(year => parseInt(year))
          .sort((a, b) => a - b);
        
        if (availableYears.length > 0) {
          return availableYears;
        }
      }
      
      // 默认提供1-10年选项
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    },
    getDomainGroup(){
      this.axios.post('/admin/data/getDomainGroup',{},{
          token : true
        }).then(res => {
          if(res.status === 200 && res.data && res.data.code === 1){
            this.groupOptions = res.data.data.list
          }else {
            this.$message.error(res.data.msg)
          }
        })
    },
    // 处理组选择变更
    handleGroupChange(row, groupId) {
      // 发送请求更新域名的组ID
      this.axios.post('/admin/data/updateDomainGroup', {
        domain_id: row.id,
        group_id: groupId
      }, {
        token: true
      }).then(res => {
        if (res.status === 200 && res.data && res.data.code === 1) {
          this.$message.success(res.data.msg);
          // 更新本地数据
          row.group_id = groupId;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {
        this.$message.error(error);
      });
    },
    clearGroup(){
      this.filterForm.group_id = null
      this.fetchDomainList()
    },
    editDns(){
      this.domainDnsForm = {
        radio: 1,
        DNS1: '',
        DNS2: '',
        DNS3: '',
        DNS4: '',
        DNS5: '',
        DNS6: ''
      }
      for (let i = 1; i <= 6; i++) {
        const dnsValue = this.whoisDialog.info[`dns${i}`];
        if (dnsValue) {
          console.log(`DNS${i}:`, dnsValue);
          this.domainDnsForm[`DNS${i}`] = dnsValue;
          this.totalDns = i;
          // 其他处理...
        }
      }
      this.whoisDialog.innerVisible = true
    },
    submitDnsForm(){
      this.$refs.domainDnsForm.validate(valid => {
        if (valid) {
          let params
          if(this.domainDnsForm.radio === 1){
            params = {
              domain: this.whoisDialog.domain.domain,
              dns1: this.domainDnsForm.DNS1,
              dns2: this.domainDnsForm.DNS2,
              dns3: this.domainDnsForm.DNS3,
              dns4: this.domainDnsForm.DNS4,
              dns5: this.domainDnsForm.DNS5,
              dns6: this.domainDnsForm.DNS6
            };
          }else {
            params = {
              domain: this.whoisDialog.domain.domain,
              dns1: this.domainDnsDefForm.DNS1,
              dns2: this.domainDnsDefForm.DNS2
            }
          }
          this.axios.post('/admin/domain/updateDomainDns',params,{
            token : true
          }).then(res => {
            if(res.status === 200 && res.data && res.data.code === 1){
              this.$message.success(res.data.msg)
            }else {
              this.$message.error(res.data.msg)
            }
          }).catch(error => {
            this.$message.error(error)
          }).finally(() => {
            this.handleWhois(this.whoisDialog.domain)
            this.whoisDialog.innerVisible = false
          })
        }
      });

    }
  }
}
</script>

<style scoped>
.domain-container {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 22px;
  color: #303133;
}

.filter-container {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.domain-name {
  display: flex;
  align-items: center;
}

.domain-name span {
  margin-right: 10px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.delete-btn {
  color: #F56C6C;
}

.price-calculation {
  font-size: 16px;
  margin-top: 15px;
}

.price {
  color: #ff6600;
  font-weight: bold;
  font-size: 18px;
}

.dns-actions {
  margin-bottom: 15px;
}

.whois-dialog {
  padding: 10px;
}

.whois-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
}

.whois-info pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
  font-family: Monaco, monospace;
  font-size: 14px;
  line-height: 1.5;
}

.section-title {
  font-size: 16px;
  color: #303133;
  margin: 20px 0 10px 0;
  padding-left: 10px;
  border-left: 3px solid #409EFF;
}

/* 第一个标题不需要上边距 */
.section-title:first-child {
  margin-top: 0;
}

.el-descriptions {
  margin-bottom: 20px;
}

.el-descriptions-item__label {
  font-weight: bold;
  color: #606266;
}

.el-descriptions-item__content {
  color: #303133;
}

/* 为敏感信息添加特殊样式 */
.sensitive-info {
  font-family: monospace;
  color: #606266;
}

.el-tabs--border-card {
  box-shadow: none;
  border: none;
}

.el-tabs__item {
  font-size: 14px;
}

.el-tabs__content {
  padding: 15px 0;
}

.whois-dialog .el-descriptions {
  width: 100%;
}

.tab-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.tab-header i {
  margin-right: 8px;
  color: #409EFF;
}

.el-tabs__nav {
  background-color: #f5f7fa;
}

.el-tabs__item.is-active {
  background-color: #fff;
  color: #409EFF;
  border-bottom: 2px solid #409EFF;
}

.whois-dialog .el-tabs__content {
  background-color: #fff;
  padding: 20px;
}
</style>